import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

/**
 * Enhanced service to update request data with better error handling
 */
export function updateRequestData(value) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            // Validate payload before sending
            if (!value.requestId) {
                return reject(new Error('Request ID is required'));
            }

            // Remove any undefined or null values from the payload
            const cleanedValue = Object.fromEntries(
                Object.entries(value).filter(([_, v]) => v !== undefined && v !== null)
            );

            Http.post(INSPECTION_URL + 'update_request_data/', cleanedValue)
                .then((res) => {
                    // Check if the response indicates success
                    if (res.data && res.data.success) {
                        return resolve(res.data);
                    } else {
                        // Handle cases where success is false
                        const errorMessage = res.data?.message || 'Update failed';
                        return reject(new Error(errorMessage));
                    }
                })
                .catch((err) => {
                    // Enhanced error handling
                    let errorMessage = 'Failed to update data';
                    
                    if (err.response) {
                        // Server responded with error status
                        if (err.response.data?.message) {
                            errorMessage = err.response.data.message;
                        } else if (err.response.data?.errors) {
                            errorMessage = err.response.data.errors.join(', ');
                        } else {
                            errorMessage = `Server error: ${err.response.status}`;
                        }
                    } else if (err.request) {
                        // Network error
                        errorMessage = 'Network error - please check your connection';
                    } else if (err.message) {
                        // Other error
                        errorMessage = err.message;
                    }
                    
                    return reject(new Error(errorMessage));
                });
        });
}

/**
 * Batch update multiple fields at once
 */
export function updateMultipleFields(requestId, fields) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            if (!requestId) {
                return reject(new Error('Request ID is required'));
            }

            if (!fields || typeof fields !== 'object') {
                return reject(new Error('Fields object is required'));
            }

            const payload = {
                requestId,
                ...fields
            };

            dispatch(updateRequestData(payload))
                .then(resolve)
                .catch(reject);
        });
}

/**
 * Update a single field
 */
export function updateSingleField(requestId, fieldName, fieldValue) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            if (!requestId) {
                return reject(new Error('Request ID is required'));
            }

            if (!fieldName) {
                return reject(new Error('Field name is required'));
            }

            const payload = {
                requestId,
                [fieldName]: fieldValue
            };

            dispatch(updateRequestData(payload))
                .then(resolve)
                .catch(reject);
        });
}